import React, { useState, useEffect } from "react";
import right_01_01 from "../assets/right_01_01.png";
import right_01_02 from "../assets/right_01_02.png";
import right_01_03 from "../assets/right_01_03.png";
import "./right.scss";
import Block from "../components/Block";
import right_01_select from "../assets/right_01_select.png";
import ScrollAnimate from "../components/ScrollAnimate";
import inspectionnew from "@api/inspectionnew";
import { Tag, Spin } from "antd";
import { defectStatus, defectStatusColor } from "@utils/common";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

const StatusData = ["待巡检", "巡检中", "部分完成", "已完成"];
const colorStatus = ["#FF3819", "#2db7f5", "#24ADF3", "#2465F3"];

const TabList = withRouter(({ screenInfo }) => {
  const [info, setInfo] = useState([
    { label: "缺陷单", value: 0, icon: right_01_02 },
    { label: "工单", value: 0, icon: right_01_03 },
    { label: "漏检任务", value: 0, icon: right_01_01 },
  ]);

  //列表data
  const [listData, setListData] = useState([]);
  //列表columns
  const [listColumns, setListColumns] = useState([]);
  //当前选中的tab
  const [activeIndex, setActiveIndex] = useState(0);
  //loading
  const [loading, setLoading] = useState(false);

  //获取漏检任务列表
  const getLeakData = async () => {
    setLoading(true);
    const res = await inspectionnew.patrolTaskLeakLs({
      stationId: screenInfo.stationId,
      pageNum: 1,
      pageSize: 999
    });
    setLoading(false);
    const { total } = res.data;
    setInfo((prevInfo) =>
      prevInfo.map((item) =>
        item.label === "漏检任务" ? { ...item, value: total } : item
      )
    );
    setListData(res.data.data);
    setListColumns([
      {
        title: "任务名称",
        span: 12,
        dataIndex: "taskGroupName",
        render: (val) => <div title={val}>{val}</div>,
      },
      {
        title: "巡检状态",
        span: 4,
        dataIndex: "taskStatus",
        render: (val) => <Tag color={colorStatus[val]}>{StatusData[val]}</Tag>,
      },
      { title: "开始时间", span: 8, dataIndex: "beginTime" },
    ]);
  };

  //获取工单列表
  const getWorkOrderData = async () => {
    setLoading(true);
    const res = await inspectionnew.workOrder({
      stationId: screenInfo.stationId,
      pageNum: 1,
      pageSize: 999,
      statusList: [0, 1]
    });
    setLoading(false);
    const { total } = res.data;
    setInfo((prevInfo) =>
      prevInfo.map((item) =>
        item.label === "工单" ? { ...item, value: total } : item
      )
    );
    setListData(res.data.data);
    setListColumns([
      { title: "工单标题", span: 8, dataIndex: "workOrderTitle" },
      { title: "处理人", span: 8, dataIndex: "handleUserNames" },
      { title: "开始处理时间", span: 8, dataIndex: "beginTime" },
    ]);
  };

  //获取缺陷单列表
  const getDefectQueryData = async () => {
    setLoading(true);
    const res = await inspectionnew.defectQuery({
      stationId: screenInfo.stationId,
      pageNum: 1,
      pageSize: 999,
      handleStatusList: [0, 1]
    });
    setLoading(false);
    const { total } = res.data;
    setInfo((prevInfo) =>
      prevInfo.map((item) =>
        item.label === "缺陷单" ? { ...item, value: total } : item
      )
    );
    setListData(res.data.data);
    setListColumns([
      {
        title: "设备名称",
        span: 4,
        dataIndex: "deviceName",
        render: (val) => <div title={val}>{val}</div>,
      },
      {
        title: "缺陷描述",
        span: 8,
        dataIndex: "deffectRemark",
        render: (val) => <div title={val}>{val}</div>,
      },
      {
        title: "状态",
        span: 4,
        dataIndex: "handleStatus",
        render: (val) => (
          <Tag color={defectStatusColor(val - 0)}>{defectStatus(val - 0)}</Tag>
        ),
      },
      { title: "部门负责人", span: 8, dataIndex: "deptLeaderName" },
    ]);
  };

  //选中改变
  useEffect(() => {
    setListData([]);
    setListColumns([]);
    if (activeIndex === 2) {
      getLeakData();
    } else if (activeIndex === 1) {
      getWorkOrderData();
    } else if (activeIndex === 0) {
      getDefectQueryData();
    }
  }, [activeIndex]);

  //初始化获取一次
  useEffect(() => {
    if (!screenInfo.stationId) return;
    getLeakData();
    getWorkOrderData();
    getDefectQueryData();
  }, [screenInfo.stationId]);
  return (
    <>
      {/* tab选项卡 */}
      <div className="flex flexBetween alignItemCenter mt32">
        {info &&
          info.map((item, index) => {
            return (
              <Block
                key={index}
                icon={<img src={item.icon} />}
                label={item.label}
                value={item.value}
                onClick={() => setActiveIndex(index)}
              />
            );
          })}
      </div>

      {/* 选中样式 */}
      <div className="mt14">
        <img
          src={right_01_select}
          className={`active_img`}
          style={{ left: `${activeIndex * 30}%` }}
        />
        {/* 列表内容 */}
        <div className="selected_content">
          {listData.length === 0 && !loading ? (
            <div
              style={{
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              暂无数据
            </div>
          ) : loading ? (
            <div
              style={{
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Spin />
            </div>
          ) : (
            <ScrollAnimate data={listData} columns={listColumns} />
          )}
        </div>
      </div>
    </>
  );
});

const comp = connect((state) => {
  return {
    ...state.Common,
  };
})(TabList);

comp.displayName = "TabList";
export default comp;
